import './assets/css/tailwind.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'   // 新增
import App from './App.vue'
import router from './router'
import store from './store'           // 你原来的 Vuex（可暂时保留，后续可移除）
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import request from '@/utils/axios'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)      // 注册 Pinia
app.use(store)      // 暂时保留原来的 Vuex（过渡期）
app.use(router)
app.use(ElementPlus)

// 全局挂载 request（兼容旧代码）
app.config.globalProperties.$request = request

app.mount('#app')

// 初始化认证状态
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()
authStore.initAuth()